import _ from 'underscore';
import Backbone from 'backbone';
import TrackerCollection from 'core/collections/tracker';
import ActivityGroup from 'models/activity_group';


export default TrackerCollection.extend({
  urlRoot: API_PREFIX + window.Urls['tracker_api:api_dispatch_list']({
    api_name: API_VERSION,
    resource_name: 'activity_group',
  }),
  model: ActivityGroup
});

/* Activity groups

    Example GET request:
        https://moodhacker.orcasdemo.com/api/tracker/v2/activity_group/?format=json&username=<username>&api_key=<api_key>

    Response:
    {
        "meta": {
            "limit": 0,
            "offset": 0,
            "total_count": 9
        },
        "objects": [
            {
                "description": "Activities to get you moving",
                "id": 1,
                "name": "Active",
                "resource_uri": "/api/tracker/v2/activity_group/1/",
                "slug": "Active"
            },
            {
                "description": "Activities to get you connected",
                "id": 2,
                "name": "Social",
                "resource_uri": "/api/tracker/v2/activity_group/2/",
                "slug": "Social"
            },
            {
                "description": "Activities that get you productive",
                "id": 3,
                "name": "Productive",
                "resource_uri": "/api/tracker/v2/activity_group/3/",
                "slug": "Productive"
            },
            {
                "description": "Activities that get you mindful",
                "id": 4,
                "name": "Mindful",
                "resource_uri": "/api/tracker/v2/activity_group/4/",
                "slug": "Mindful"
            },
            {
                "description": "Activities that get you positive",
                "id": 5,
                "name": "Positive",
                "resource_uri": "/api/tracker/v2/activity_group/5/",
                "slug": "Positive
            },
            {
                "description": "Activities that stimulate your senses",
                "id": 6,
                "name": "Sensory",
                "resource_uri": "/api/tracker/v2/activity_group/6/",
                "slug": "Sensory"
            },
            {
                "description": "Activities that nurture you",
                "id": 7,
                "name": "Nurturing",
                "resource_uri": "/api/tracker/v2/activity_group/7/",
                "slug": "Nurturing"
            },
            {
                "description": "Activities that are creative",
                "id": 8,
                "name": "Creative",
                "resource_uri": "/api/tracker/v2/activity_group/8/",
                "slug": "Creative"
            },
            {
                "description": "Activities that you customize",
                "id": 9,
                "name": "Custom",
                "resource_uri": "/api/tracker/v2/activity_group/9/",
                "slug": "Custom"
            }
        ]
    }

*/



// WEBPACK FOOTER //
// ./static/js/collections/activity_group.js